import { ResourceAppModule } from "@/shared/app";
import { plmApp } from "../app";
import {
  jednostkaSprzedazyResource,
  JednostkaSprzedazy,
} from "@megarax/client/src/resources/plm";
import { getDefaultModuleComponents } from "@/components/nameResource/components";

export const jednostkaSprzedazyModule: ResourceAppModule = {
  ...getDefaultModuleComponents(jednostkaSprzedazyResource),
  route: "jednostkaSprzedazy",
  title: "Jednostki sprzedaży",
  app: plmApp,
  itemConstructor: JednostkaSprzedazy,
  resource: jednostkaSprzedazyResource,
  iconClass: "fas fa-weight-hanging fa-fw",
};
